import React, { useState } from 'react';
import "../Casinoholdem/NewUI/Holdempayout.scss";


const payoutData = {
    ante: [
        { hand: "Royal Flush", payout: "Bet X 100" },
        { hand: "Straight Flush", payout: "Bet X 20" },
        { hand: "Four of a Kind", payout: "Bet X 10" },
        { hand: "Full House", payout: "Bet X 3" },
        { hand: "Flush", payout: "Bet X 2" },
        { hand: "Straight", payout: "Bet X 1" },

        { hand: "Three of a Kind", payout: "Bet X 1"},
        { hand: "Two Pair", payout: "Bet X 1" },
        { hand: "Pair",payout: "Bet X 1" },
    ],
    bonus: [
        { hand: "Royal Flush", payout: "Bet X 100" },
        { hand: "Straight Flush", payout: "Bet X 50" },
        { hand: "Four of a Kind", payout: "Bet X 40" },
        { hand: "Full House", payout: "Bet X 30" },
        { hand: "Flush", payout: "Bet X 20"},
        { hand: "Straight", payout: "Bet X 7" },
        { hand: "Three of a Kind", payout: "Bet X 7"},
        { hand: "Two Pair", payout: "Bet X 7" },
        { hand: "Pair of Aces", payout: "Bet X 7" }
    ],
};

function Holdempayout() {
    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState("ante");

    const openModal = () => {
        setShowModal(true);
        setSelected("ante");
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const renderTable = () => {
        return (
            <table className="payout-table">
                <thead>
                    <tr>
                        <th>Hand</th>
                        <th>Payout</th>
                    </tr>
                </thead>
                <tbody>
                    {payoutData[selected].map((row, idx) => (
                        <tr key={idx}>
                            <td>{row.hand}</td>
                            <td>{row.payout}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <div className="info-container">
            <span
                className="info-icon"
                title="Click to view Payout Options"
                onClick={openModal}
            >
                {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="#bac1d6"
                >
                    <path d="M11 17h2v-6h-2v6zm0-8h2V7h-2v2zm1-7C6.48 2 2 6.48 
                    2 12s4.48 10 10 10 10-4.48 
                    10-10S17.52 2 12 2zm0 
                    18c-4.41 0-8-3.59-8-8s3.59-8 
                    8-8 8 3.59 8 8-3.59 8-8 8z" />
                </svg> */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon"
                    viewBox="0 0 24 24"
                >
                    <path d="M11 17h2v-6h-2v6zm0-8h2V7h-2v2zm1-7C6.48 2 2 6.48 
      2 12s4.48 10 10 10 10-4.48 
      10-10S17.52 2 12 2zm0 
      18c-4.41 0-8-3.59-8-8s3.59-8 
      8-8 8 3.59 8 8-3.59 8-8 8z"/>
                </svg>
            </span>

            {showModal && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal" onClick={closeModal}>
                            ✖
                        </button>

                        <div className="modal-header">
                            <button
                                className={`buttonsholdem ${selected === "ante" ? "active" : ""}`}
                                onClick={() => setSelected("ante")}
                            >
                                Ante
                            </button>
                            <button
                                className={`buttonsholdem ${selected === "bonus" ? "active" : ""}`}
                                onClick={() => setSelected("bonus")}
                            >
                                Bonus
                            </button>
                        </div>

                        <div className="modal-body">
                            <h3>{selected === 'ante' ? 'Ante Payouts' : 'Bonus Payouts'}</h3>
                            {renderTable()}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Holdempayout;
